import { ListItem } from '../../../shared/list-confirmation/model/list-item';

export class Deposit {
	numberBankSlip: string;
	generatedIn: string;
	payeeName: string;
	value: any;
	maturity: string;
	digitableLine: string;
	message: string;
	success: boolean = false;
	resumeList: Array<ListItem>;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/deposit-per-ticket/models/deposit.ts